import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    savedMessage: translate({ id: 'transactionBar.messages.saved' }),
  }))

  return api
}
